
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...url1]]",
      function () {
        return require("private-next-pages/[[...url1]]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...url1]]"])
      });
    }
  